import { EnglishDictionary } from './en';

const es: EnglishDictionary = {
  login: {
    title: 'Hola',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    submit: 'Iniciar sesión',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate',
    intro: 'Inicia sesión en tu cuenta',
    success: 'Sesión iniciada con éxito',
    error: 'Error al iniciar sesión',
    missingCredentials: 'Por favor, ingresa un correo electrónico y contraseña válidos.',
    blocked: 'Tu cuenta ha sido desactivada temporalmente.',
  },
  changePassword: {
    title: 'Cambiar Contraseña',
    intro:
      'Confirme la dirección de correo electrónico de su cuenta y le enviaremos un código para restablecer su contraseña.',
    email: 'Correo electrónico',
    login: 'Iniciar sesión',
    oneTimeCode: 'Código de un solo uso',
    confirmPassword: 'Confirmar Contraseña',
    newPassword: 'Nueva Contraseña',
    minPassword: 'La contraseña debe tener al menos 6 caracteres',
    enterOTP: 'Por favor ingresa el código OTP enviado a tu correo electrónico.',
    verifyOTP: 'Verificar OTP',
    sentOTP: 'OTP enviado a tu correo electrónico',
    errorSendingOTP:
      'No se pudo enviar el correo con el código de un solo uso. Inténtalo de nuevo o contacta con soporte.',
    invalidOTP: 'OTP inválido',
    verifiedOTP: 'OTP verificado exitosamente',
    passwordChanged: 'Contraseña cambiada exitosamente',
    errorChangingPassword: 'Error al cambiar la contraseña',
    buttonText: 'Cambiar contraseña',
    errorNoUser: 'No hay ningún usuario asociado a la dirección de correo electrónico {email}.',
  },
  logout: {
    success: 'Has cerrado sesión exitosamente.',
    error: 'Hubo un error al cerrar sesión.',
  },
  resetPassword: {
    title: 'Restablecer contraseña',
    email: 'Correo electrónico',
    submit: 'Enviar enlace',
    backToLogin: 'Volver al inicio de sesión',
    success: 'Correo de restablecimiento enviado',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    changePassword: 'Cambiar contraseña',
  },
  validation: {
    required: 'Este campo es requerido',
    invalidEmail: 'Correo electrónico inválido',
    passwordMismatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
  },
  fields: {
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    doctor: 'Doctor',
    indications: 'Indicaciones',
    notes: 'Notas',
    id: 'ID',
    patientId: 'ID del Paciente',
    dateOfBirth: 'Fecha de Nacimiento',
    gender: 'Género',
    created: 'Fecha de Adición',
    createdAt: 'Creado en',
    updatedAt: 'Actualizado en',
    createdBy: 'Creado por',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    fileSize: 'Tamaño del archivo',
    revisionHistory: 'Historial de revisiones',
    exportStatus: 'Estado de exportación',
  },
  patientsPage: {
    title: 'Pacientes',
    description: 'Gestiona tus pacientes',
    newPatient: 'Nuevo Paciente',
    instructions: `##### **¿A quién estás añadiendo?**
Rellena los campos para crear un perfil de paciente.
##### **Consejos:**
- indica un campo obligatorio
- Rellenar el campo opcional puede ser útil más tarde
- Todos los datos del paciente se almacenan de forma anónima`,
  },
  addPatientPage: {
    title: 'Añadir Paciente',
    description: 'Añadir un nuevo paciente al sistema',
    success: 'Paciente añadido con éxito',
    error: 'Error al añadir paciente',
    submitText: 'Añadir Paciente',
  },
  sections: {
    generalPatientInformation: 'Información General del Paciente',
    medicalInformation: 'Información Médica',
    orderInformation: 'Información del pedido',
  },
  placeholders: {
    fullName: 'Ingrese el nombre completo',
    email: 'Ingrese el correo electrónico',
    phone: 'Ingrese el número de teléfono',
    doctor: 'Ingrese la información del doctor',
    indications: 'Ingrese la información de las indicaciones',
    notes: 'Ingrese las notas',
    patientId: 'Ingrese el ID del paciente',
    dateOfBirth: 'Ingrese la fecha de nacimiento',
    gender: 'Ingrese el género',
    password: 'Ingrese la contraseña',
    confirmPassword: 'Confirme su contraseña',
    companyName: 'Ingrese el nombre de la empresa',
    clientId: 'Ingrese el ID del cliente',
    line1: 'Ingrese la dirección línea 1',
    city: 'Ingrese la ciudad',
    postalCode: 'Ingrese el código postal',
    country: 'Ingrese el país',
    state: 'Ingrese el estado',
  },
  onUpdate: {
    title: 'Actualizar Paciente',
    success: 'Paciente actualizado con éxito',
    error: 'Error al actualizar paciente',
  },
  onUpdateOrder: {
    title: 'Actualizar pedido',
    success: 'Pedido actualizado correctamente',
    error: 'Error al actualizar el pedido',
  },
  onDelete: {
    title: 'Eliminar Paciente',
    message:
      '¿Está seguro de que desea eliminar este paciente? Todos los escaneos 3D, E-limbs y productos sin terminar vinculados a este paciente serán eliminados. Los productos pedidos se mantendrán en la página de pedidos, pero no se podrán cambiar.',
    confirmText: 'Eliminar',
    success: 'Paciente eliminado con éxito',
    error: 'Error al eliminar paciente',
    elimb: {
      title: 'Borrar E-limb',
      message: '¿Está seguro de que desea eliminar esta E-limb?',
      success: 'E-limb eliminado con éxito',
      error: 'Error al borrar la E-limb',
    },
    scan: {
      title: 'Borrar exploración',
      message: '¿Está seguro de que desea eliminar esta exploración?',
      success: 'Escaneado eliminado con éxito',
      error: 'Error al borrar la exploración',
    },
  },
  onDeleteUser: {
    title: 'Eliminar Usuario',
    message:
      '¿Está seguro de que desea eliminar este usuario? Todos los pacientes, productos pedidos, escaneos 3D y E-limbs vinculados a este usuario serán transferidos a un usuario diferente.',
    transferTo: 'Por favor, especifique a quién se transferirán los datos:',
    confirmText: 'Eliminar',
    success: 'Usuario eliminado con éxito',
    error: 'Error al eliminar usuario',
    selectUserToTransfer: 'Seleccionar usuario al que se transferirán los datos',
    noUserToTransfer: 'No hay usuario para transferir',
    lastAdmin: 'Siempre debe haber al menos un administrador. Para cambiar esto, contacta con OTB.',
    forbidden: 'No tienes permiso para eliminar esta cuenta.',
    referenced:
      'Esta cuenta sigue vinculada a otros registros y no se pudo eliminar. No se cambió nada — contacta con OTB.',
    invalidTransfer:
      'Los datos solo se pueden transferir a otro usuario activo de la misma empresa. No se cambió nada — elige otro usuario.',
  },
  onCreatePatient: {
    existingPatientName: {
      title: 'Paciente existente',
      message:
        'Ha creado un paciente con el mismo nombre que un paciente ya existente: {fullName}.\n¿Desea guardar esto como un nuevo paciente o editar el paciente existente?',
      confirmText: 'Guardar como nuevo paciente',
      cancelText: 'Editar paciente existente',
    },
    existingPatientId: {
      title: 'Paciente existente',
      message:
        'Ha creado un paciente con el mismo ID que un paciente ya existente: {fullName}.\n¿Desea editar el paciente existente o cancelar la creación del nuevo paciente?',
      confirmText: 'Editar paciente existente',
      cancelText: 'Cancelar creación de paciente',
      cancelMessage: 'Creación de paciente cancelada',
    },
  },
  onEditPatient: {
    existingPatientName: {
      title: 'Paciente existente',
      message:
        'Ha actualizado un paciente con el mismo nombre de un paciente ya existente: {fullName}.\n¿Desea aplicar sus cambios al paciente actual?',
      confirmText: 'Aplicar cambios',
      cancelText: 'Cancelar actualización del paciente',
    },
  },
  actions: {
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver Paciente',
    add: 'Añadir Paciente',
    save: 'Guardar',
    cancel: 'Cancelar',
    continue: 'Continuar',
    reorder: 'Volver a pedir',
    duplicate: 'Duplicar',
    duplicateConfig: 'Duplicar y actualizar la configuración',
    addToCart: 'Añadir al carrito',
    removeFromCart: 'Eliminar del carrito',
    upload: 'Subir',
    review: 'Revisar producto',
  },
  messages: {
    created: 'Paciente creado',
    updated: 'Paciente actualizado',
    deleted: 'Paciente eliminado',
    createError: 'Error al crear paciente',
    updateError: 'Error al actualizar paciente',
    deleteError: 'Error al eliminar paciente',
  },
  confirmations: {
    update: {
      title: 'Actualizar',
      message: '¿Está seguro de que desea actualizar este elemento?',
      confirmText: 'Actualizar',
    },
    delete: {
      title: 'Eliminar',
      message: '¿Está seguro de que desea eliminar este elemento?',
      confirmText: 'Eliminar',
    },
    create: {
      confirmText: 'Crear',
    },
  },
  overviewPage: {
    title: 'Resumen del Paciente',
    description: 'Ver y gestionar detalles del paciente',
    newProduct: 'Nuevo Producto',
    noProducts: 'No hay productos disponibles',
    productId: 'ID del Producto',
    productType: 'Tipo de Producto',
    createdOn: 'Creado el',
    status: 'Estado',
    newScan: 'Nuevo Escaneo',
    noScans: 'No hay escaneos disponibles',
    scanId: 'ID del Escaneo',
    scanName: 'Nombre del Escaneo',
    scannedLimb: 'Miembro Escaneado',
    newElimb: 'Nuevo E-limb',
    noElimbs: 'No hay e-limbs disponibles',
    elimbId: 'ID del E-limb',
    elimbType: 'Tipo de E-limb',
    editNotes: 'Editar Notas',
    notesUpdated: 'Notas actualizadas con éxito',
    notesUpdateError: 'Error al actualizar las notas',
    scans: 'Escaneos',
    elimbs: 'E-limbs',
    products: 'Productos',
  },

  admin: {
    title: 'Panel de Administración',
  },
  users: {
    title: 'Usuarios',
    add: 'Añadir Usuario',
    edit: 'Editar Usuario',
    delete: 'Eliminar Usuario',
    sections: {
      generalInfo: 'Información General',
      loginInfo: 'Información de Inicio de Sesión',
      roles: 'Roles',
      passwordPicker: {
        title: '¿Quién tiene que establecer la contraseña?',
        true: 'Tú',
        false: 'El usuario',
      },
      warning: {
        alert: 'Este usuario aún no ha configurado una contraseña.',
        button: 'Enviar un nuevo correo electrónico',
      },
      platformAccess: {
        title: 'Acceso a la plataforma',
        field: 'Bloqueado',
      },
    },
    roles: {
      professional: 'Profesional',
      admin: 'Administrador',
      distributor: 'Distribuidor',
      master: 'Maestro',
    },
    fields: {
      id: 'ID',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      createdAt: 'Creado el',
      orderedProducts: 'Productos pedidos',
      unfinishedProducts: 'Productos sin terminar',
      roles: 'Roles',
    },
    instructions: 'Instrucciones para gestionar usuarios',
  },
  companies: {
    title: 'Empresas',
    add: 'Añadir Empresa',
    edit: 'Editar Empresa',
    delete: 'Eliminar Empresa',
    new: 'Nueva Empresa',
    description: 'Crear una nueva empresa',
    filterByDistributor: 'Filtrar por distribuidor',
    addDistributor: 'Añadir distribuidor',
    sections: {
      generalInfo: 'Información general de la empresa',
      settings: 'Configuración',
      address: 'Dirección',
      users: 'Usuarios',
      companyOverview: 'Información general sobre la empresa',
      productWorkflows: 'Flujos de trabajo de productos',
      supportTickets: 'Tickets de soporte',
      orderedProducts: 'Productos pedidos',
      advancedSettings: 'Configuración avanzada',
      productWorkflowStepConfigurationCard: {
        title: 'Mostrar / ocultar pasos del flujo de trabajo de productos {material}',
      },
    },
    fields: {
      name: 'Nombre de la empresa',
      clientId: 'ID del cliente (al menos 4 caracteres)',
      clientIdHeader: 'ID del cliente',
      generalEmail: 'Dirección de correo electrónico general',
      generalPhone: 'Número de teléfono general',
      fullName: 'Nombre completo',
      deletedUser: 'Usuario eliminado',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      line1: 'Dirección',
      city: 'Ciudad & código postal',
      state: 'Estado/Provincia',
      postalCode: 'Código postal',
      country: 'País',
      createdBy: 'Creador',
      dateCreated: 'Fecha de creación',
      id: 'ID',
      openSupportTickets: 'Tickets de soporte abiertos',
      orderedProducts: 'Productos pedidos',
      users: 'Usuarios',
      unfinishedProducts: 'Productos sin terminar',
    },
    settings: {
      useOwnPatientId: {
        label: 'Usar ID de paciente propio',
        description:
          'Al marcar esta casilla, podrá definir su propio ID de paciente, convirtiéndolo en un campo obligatorio. Al desmarcar esta casilla, la plataforma generará los ID de paciente aleatoriamente.',
      },
      sharePatients: {
        label: 'Compartir pacientes entre usuarios',
        description:
          'Al marcar esta casilla, todos los usuarios dentro de esta organización pueden ver, editar y crear productos para todos los pacientes. Al desmarcar esta casilla, solo el usuario que crea un paciente puede ver, editar o crear un producto para el paciente.',
      },
      useShippingInformation: {
        label: 'Usar información de envío para empresas filiales',
        description:
          'Al marcar esta casilla, todos los productos pedidos por empresas creadas por esta organización se enviarán y vincularán a este distribuidor. (No editable por el administrador de la empresa)',
      },
      adminOrderFollowUp: {
        label: 'El administrador se incluye en el seguimiento de pedidos de la empresa.',
        description:
          'Al marcar esta casilla, los administradores reciben un correo electrónico cuando se pide un producto.',
      },
      orderReferenceFollowUp: {
        label: 'Recordatorios de referencia de pedido.',
        description:
          'Al marcar esta casilla, recibirá un recordatorio diario para rellenar la referencia de su pedido si aún no lo ha hecho.',
      },
      credits: {
        title: 'Créditos',
      },
      onlyAdminsCanBuyCredits: {
        label: 'Solo los administradores pueden comprar créditos',
        description:
          'Al marcar esta casilla, los profesionales solo pueden solicitar créditos y los administradores los compran.',
      },
      pricePerCredit: {
        label: 'Precio por crédito (EUR)',
        description:
          'Lo que cuesta un crédito a esta organización en euros. Deja 0 para usar el precio de su distribuidor o, si no, el de Orthobroker.',
      },
      creditPriceCarpi: {
        label: 'Carpi (créditos)',
        description:
          'Créditos, no euros, que se cobran por un STL de Carpi. Cero usa el valor de su distribuidor o, si no, el de Orthobroker.',
      },
      creditPriceMino: {
        label: 'Mino (créditos)',
        description:
          'Créditos, no euros, que se cobran por un STL de Mino. Cero usa el valor de su distribuidor o, si no, el de Orthobroker.',
      },
      creditPriceVolar: {
        label: 'Volar (créditos)',
        description:
          'Créditos, no euros, que se cobran por un STL de Volar. Cero usa el valor de su distribuidor o, si no, el de Orthobroker.',
      },
      creditPacks: {
        title: 'Paquete de créditos {pack}',
        visible: {
          label: 'Mostrar este paquete',
          description: 'Ofrecerlo en la página de créditos de esta empresa.',
        },
        credits: 'Créditos',
        discount: 'Descuento (%)',
      },
      notifications: {
        success: 'Configuración de la empresa actualizada.',
        error: 'Se ha producido un error al actualizar la configuración de la empresa.',
      },
    },
    whitelabel: {
      title: 'Marca blanca',
      logo: {
        label: 'Logotipo de la empresa',
        description:
          'Sustituye al logotipo de OrthoSolid para los usuarios de esta empresa. PNG, JPG o WebP, hasta 2 MB.',
        upload: 'Elegir imagen',
        remove: 'Eliminar logotipo',
        removeTitle: 'Eliminar el logotipo de la empresa',
        removeMessage:
          '¿Eliminar el logotipo de esta empresa? Sus usuarios volverán a ver el logotipo de OrthoSolid.',
        empty: 'Sin logotipo de empresa: los usuarios ven el logotipo de OrthoSolid.',
      },
      notifications: {
        success: 'Se ha actualizado el logotipo de la empresa.',
        removed: 'Se ha eliminado el logotipo de la empresa.',
        error: 'Se ha producido un error al actualizar el logotipo de la empresa.',
        notAllowed: 'Solo los usuarios master pueden cambiar el logotipo de la empresa.',
        noFile: 'Elija primero una imagen.',
        invalidType: 'Ese archivo no es una imagen compatible. Use PNG, JPG o WebP.',
        tooLarge: 'Esa imagen es demasiado grande. El tamaño máximo es 2 MB.',
      },
    },
    actions: {
      create: {
        errorPrefix: 'Error al crear la empresa:',
      },
      delete: {
        button: 'Eliminar empresa',
        title: 'Eliminar empresa',
        message: '¿Está seguro de que desea eliminar esta empresa?',
        success: 'La empresa ha sido eliminada exitosamente',
        error: 'Ocurrió un error al eliminar la empresa',
      },
      edit: {
        success: 'La empresa se ha actualizado correctamente.',
        errorPrefix: 'Error al actualizar la empresa:',
      },
      companyID: 'Es necesario indicar el número de identificación de la empresa.',
      error:
        'El ID del cliente solo puede contener letras, números, puntos, guiones y guiones bajos.',
      saveDecisionFlowOptions: {
        success: 'Se guardaron las opciones que esta empresa puede elegir en {flow}.',
        notAllowed:
          'Solo puedes definir las opciones de las empresas que registraste, dentro de tus propias opciones.',
        error:
          'No se pudieron guardar las opciones de {flow}. Recarga la página e inténtalo de nuevo.',
      },
      toggleProductWorkflowStepConfigurations: {
        field: 'Alternar pasos del flujo de trabajo de productos {material}',
        productionLocation: {
          title: 'Lugar de producción',
        },
        material: {
          title: 'Material',
        },
        thumbSupport: {
          title: 'Soporte para el pulgar',
        },
        braceLength: {
          title: 'Longitud de la abrazadera',
        },
        openingLocation: {
          title: 'Ubicación de la inauguración',
        },
        hinges: {
          title: 'Bisagras',
        },
        hingedOption: {
          title: 'Opción con bisagras',
        },
        padding: {
          title: 'Acolchado',
        },
        extraPadding: {
          title: 'Acolchado adicional',
        },
        straps: {
          title: 'Correas',
        },
      },
      duplicateConfig: {
        title: 'Duplicar un producto con una nueva configuración',
        noOutcome:
          'Ninguna configuración coincide con estas respuestas. Cambie una respuesta, o pida a un administrador que complete el flujo de decisión.',
      },
    },
    instructions: 'Instrucciones para gestionar empresas',
  },
  roles: {
    title: 'Roles',
    admin: 'Administrador',
    distributor: 'Distribuidor',
    master: 'Master',
    user: 'Usuario',
  },
  status: {
    pending: 'Pedido Pendiente',
    inProgress: 'Pedido En Progreso',
    completed: 'Pedido Completado',
    cancelled: 'Pedido Cancelado',
  },
  orders: {
    title: 'Pedidos',
    new: 'Nuevo Pedido',
    details: 'Detalles del Pedido',
    status: 'Estado',
    date: 'Fecha del Pedido',
    id: 'ID del Pedido',
    placeOrder: 'Realizar Pedido',
    sections: {
      generalInfo: 'Información General',
      shippingInfo: 'Información de Envío',
    },
    fields: {
      status: 'Estado',
      reference: 'Referencia',
      clientId: 'ID del Cliente',
      id: 'ID del Pedido',
      created: 'Creado',
      totalItems: 'Total de Items',
      notes: 'Notas',
      companyName: 'Empresa',
      material: 'Material',
    },
    email: {
      received:
        'Nos complace comunicarle que hemos recibido su pedido y que lo tramitaremos en breve. A continuación encontrará los detalles de su pedido:',
      beingPrepared:
        'Su pedido se está preparando y le avisaremos cuando esté en camino. Si tiene alguna pregunta o necesita más ayuda, no dude en ponerse en contacto con nosotros en orders@orthosolid.com.',
      signature:
        'Saludos cordiales\nEl equipo de Orthobroker,\nThe Orthobroker Team\nhttps://platform.orthosolid.com',
    },
  },
  shipping: {
    title: 'Información de Envío',
    name: 'Nombre Completo',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    city: 'Ciudad',
    postalCode: 'Código Postal',
    country: 'País',
  },
  preview: {
    demo: 'Vista previa demo',
    noPreview: 'Vista previa no disponible',
    noGlbFound: 'No se encontró el GLB',
    loading: 'Cargando...',
  },
  modelPreview: {
    orientationLabel: 'Orientación',
    autoOrientation: 'Orientación automática',
    autoOrientationTooltip: 'Orientación automática basada en las dimensiones del modelo',
    xAxisUp: 'Eje X arriba',
    xAxisUpTooltip: 'Rotar para hacer el eje X vertical',
    yAxisUp: 'Eje Y arriba',
    yAxisUpTooltip: 'Orientación vertical predeterminada',
    zAxisUp: 'Eje Z arriba',
    zAxisUpTooltip: 'Rotar para hacer el eje Z vertical',
    error: 'Aún no hay ningún modelo para mostrar.',
    unavailableCombination: 'Esta combinación no está disponible.',
  },
  support: {
    title: 'Solicitar ayuda',
    description1:
      'Gracias por contactarnos, estamos felices de ayudarte a resolver tu problema. Para asegurarnos de brindar el soporte adecuado a todos los usuarios, nos gustaría informarte que hay un manual completo de la plataforma que puedes consultar cuando tengas un problema.',
    description2:
      'Si tu problema no está abordado en el manual, por favor descríbelo en el cuadro a continuación. Lo revisaremos dentro de las próximas 24 horas (durante días laborables). Recibirás una notificación cuando hayamos atendido tu ticket',
    manualButton: 'Manual de la plataforma',
    issueLabel: 'Describe tu problema',
    issuePlaceholder: 'Por favor, describe tu problema aquí...',
    createButton: 'Crear ticket',
    typeLabel: 'Relacionado con',
    typePlaceholder: 'Elige un tema',
    addTicket: 'Añadir ticket',
    platformManual: 'Manual de la plataforma',
    platformManualDescription: 'Lea las directrices o busque una funcionalidad',
    academy: 'Academia',
    academyDescription: 'Conviértase en un experto a través de tutoriales en video',
    button: 'Marcar como resuelto',
    notification: {
      resolved: {
        success: 'Marcado como resuelto',
        error: 'Se ha producido un error inesperado al marcar como resuelto. Inténtalo de nuevo.',
      },
      under_investigation: {
        success: 'Marked as under investigation',
        error:
          'Se ha producido un error inesperado al marcarlo como bajo investigación. Inténtalo de nuevo.',
      },
    },
  },
  buttons: {
    back: 'Volver',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    add: 'Añadir',
    select: 'Seleccionar',
    selected: 'Seleccionado',
    discover: 'Descubrir',
    readMore: 'Leer más',
    continue: 'Continuar',
    clear: 'Limpiar',
  },
  errors: {
    notFound: {
      title: '404',
      subtitle: 'Página no encontrada',
      description: 'La página que buscas no existe o ha sido movida.',
      action: 'Volver al inicio',
    },
    general: {
      title: '¡Algo salió mal!',
      description: 'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
      action: 'Intentar de nuevo',
    },
    noAccess: 'No tiene acceso a esta página.',
    duplicate: {
      error: 'Ha surgido un error al duplicar el producto.',
    },
  },
  createUser: {
    errors: {
      alreadyExists:
        'Este usuario ya tiene una cuenta activa. Si es necesario restablecer la contraseña, ponte en contacto con tu administrador.',
      passwordLength: 'La contraseña debe tener al menos 6 caracteres.',
      error: 'Error al crear la autenticación:',
      noEmail:
        'Ha surgido un error al recuperar tu correo electrónico. Ponte en contacto con el servicio de asistencia.',
      JWTExpired: {
        new: 'Tu invitación a la plataforma OrthoSolid ha caducado. Ponte en contacto con tu administrador para que te envíe una nueva.',
        reset:
          'Tu invitación para restablecer tu contraseña ha caducado. Ponte en contacto con tu administrador para que te envíe una nueva.',
      },
    },
    subject: 'Establece tu contraseña para OrthoSolid.',
    mail: `Estimado {fullName},
    
    Tu administrador te ha creado una cuenta en la plataforma OrthoSolid.
    Accede a este enlace para crear una contraseña: {passwordURL}

    Saludos cordiales,
    El equipo de OrthoSolid. 
    `,
    html: `
      <p>Estimado {fullName},</p>
      <p>
        Tu administrador ha creado una cuenta para ti en la plataforma OrthoSolid.
        Accede a <a href="{passwordURL}">este enlace</a> para crear una contraseña.
      </p>
      <p>
        Saludos cordiales,<br />
        El equipo de OrthoSolid.
      </p>
    `,
  },
  onResetPassword: {
    message:
      'Al pulsar «Continuar», se enviará un correo electrónico al usuario. Se le redirigirá a una página en la que podrá restablecer su contraseña.',
    success: 'El correo electrónico se ha enviado al usuario',
    error: 'Ha surgido un problema al enviar el correo al usuario.',
    mail: {
      subject: 'Restablece tu contraseña para la plataforma Orthosolid.',
      text: `Estimado {fullName},
    
    Tu administrador ha solicitado que se restablezca tu contraseña.
    Accede a este enlace para restablecerla: {passwordURL}

    Saludos cordiales,
    El equipo de OrthoSolid. 
    `,
      html: `
      <p>Estimado {fullName},</p>
      <p>
        Tu administrador ha solicitado que se restablezca tu contraseña.
        Accede a <a href="{passwordURL}">este enlace</a> para restablecerla.
      </p>
      <p>
        Saludos cordiales,<br />
        El equipo de OrthoSolid.
      </p>
    `,
    },
    errorUserWithoutPassword:
      '<p>Este usuario tiene una cuenta creada, pero no tiene contraseña. Por favor, accede a <a href="{passwordURL}">este enlace</a> para poder configurarla.</p>',
  },
  common: {
    language: 'Idioma',
    loading: 'Cargando...',
    noResults: 'No se encontraron resultados',
    search: 'Buscar',
    noValue: '-',
    loadingPage: 'Cargando página...',
    loadingData: 'Cargando datos...',
    processing: 'Procesando...',
    removeFromCart: 'Eliminar del carrito',
    fields: {
      created: 'Creado',
    },
    cancel: 'Cancelar',
    hiddenData: 'Estos datos están ocultos',
  },
  onResendNewPasswordMail: {
    title: 'Enviar un correo con una nueva contraseña',
    message:
      'Al pulsar «Continuar», se enviará un correo electrónico al usuario. Se le redirigirá a una página en la que tendrá una nueva oportunidad de establecer su contraseña.',
  },
  ticketDetails: {
    generalInfo: 'Información general del ticket',
    involving: 'Relacionado con',
    ticketId: 'ID del ticket',
    scanId: 'ID del escaneo',
    createdOn: 'Creado el',
    createdBy: 'Creado por',
    lastAdjusted: 'Última modificación',
    lastAdjustedBy: 'Modificado por',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar ticket',
    deleteConfirm: '¿Está seguro de que desea eliminar este ticket?',
    deleteSuccess: 'Ticket eliminado',
    deleteError: 'Error al eliminar el ticket',
    resolveTicket: 'Resolver ticket',
    ticketResolved: 'Ticket resuelto',
  },
  productCatalogue: {
    title: 'Catálogo de Productos',
    viewAll: 'Ver todo',
  },
  discussion: {
    title: 'Discusión',
    newMessage: 'Nuevo Mensaje',
    send: 'Enviar',
    reply: 'Responder',
  },
  form: {
    save: 'Guardar cambios',
    delete: 'Eliminar',
    required: 'Requerido',
    enterValue: 'Introducir valor',
    selectDate: 'Seleccionar fecha',
    slider: {
      autoAdjust: 'Activar/desactivar cálculo automático',
    },
  },
  notes: {
    title: 'Notas',
    edit: 'Editar notas',
    placeholder: 'Introducir notas',
    updated: 'Notas actualizadas',
    updateError: 'Error al actualizar las notas',
  },
  referenceNumber: {
    title: 'Número de referencia',
    placeholder: 'Número de referencia de su pedido (si procede)',
  },
  notifications: {
    success: 'Éxito',
    error: 'Error',
    info: 'Información',
    warning: 'Advertencia',
    company: {
      created: 'Empresa creada con éxito',
      deleted: 'Empresa eliminada con éxito',
      deleteError: 'Error al eliminar la empresa',
      updated: 'Empresa actualizada con éxito',
      updateError: 'Error al actualizar la empresa',
    },
    order: {
      created: 'Pedido creado con éxito',
      createError: 'Error al crear el pedido! Póngase en contacto con el servicio de asistencia.',
      insufficientCredits:
        'No tiene créditos suficientes para este pedido. Recargue sus créditos e inténtelo de nuevo.',
      creditsMisconfigured:
        'No se pudo calcular el precio en créditos de este pedido. Póngase en contacto con OrthoSolid; comprar más créditos no lo soluciona.',
    },
    user: {
      created: 'Usuario creado con éxito',
      createError: 'Error al crear el usuario',
    },
    product: {
      addedToCart: 'Producto añadido al carrito',
      removedFromCart: 'Producto eliminado del carrito',
      cartError: 'Error al actualizar el carrito',
      duplicated: 'El producto se ha duplicado correctamente.',
      duplicatedConfig: 'El producto se ha duplicado correctamente con una nueva configuración.',
      deleted: 'Producto eliminado con éxito',
      deleteError: 'Error al eliminar el producto',
    },
    model: {
      loadError: 'Error al cargar el modelo',
    },
    message: {
      creditsLow: {
        subject: 'Saldo de créditos bajo',
        message:
          'A tu organización le quedan {balance} créditos, que no bastan para otro archivo digital. Recarga para seguir pidiendo.',
      },
      creditsRequested: {
        subject: 'Créditos solicitados',
        message: '{requesterName} ha solicitado {credits} créditos más para tu organización.',
      },
      orderPlaced: {
        subject: 'Se ha realizado el pedido #{orderId}.',
        message: 'Tu pedido se ha realizado correctamente.',
      },
      orderInProcess: {
        subject: 'Pedido #{orderId} en curso',
        message: 'Todos los productos de tu pedido se encuentran en fase de fabricación.',
      },
      orderDelayed: {
        subject: 'El pedido #{orderId} se ha retrasado',
        message:
          'Ha surgido un problema con tu pedido. Nos pondremos en contacto contigo si es necesario.',
      },
      orderShipped: {
        subject: 'Pedido #{orderId} finalizado',
        message: 'Todos los productos de tu pedido ya se han enviado y llegarán en breve.',
      },
      orderInvoiced: {
        subject: 'Pedido n.º {orderId} facturado',
        message: 'Su pedido n.º {orderId} ha sido facturado.',
      },
      productUpdated: {
        subject: 'Actualización de Producto: {productName} - {productId}',
        message:
          'El producto "{productName}" (ID: {productId}) ha sido actualizado por nuestro equipo de soporte.',
      },
      supportHasReactedToYourHelpRequest: {
        subject: '{productName} {productId} ha sido actualizado por el servicio de asistencia',
        message: 'Hemos respondido a tu solicitud de ayuda.',
      },
      announcement: {
        title: 'Nuevo anuncio',
        description:
          'Al pulsar «Enviar notificación», se enviará una notificación dentro de la plataforma a TODOS los usuarios.',
        confirmText: 'Enviar notificación',
        success: 'La notificación se ha enviado a todos los usuarios.',
        error: 'Se ha producido un error al enviar la notificación a todos los usuarios.',
        form: {
          subject: {
            title: 'Asunto',
            placeholder: 'Por favor, introduzca un asunto...',
          },
          message: {
            title: 'Mensaje',
            placeholder: 'Escriba su mensaje...',
          },
          link: {
            title: 'Link',
            placeholder: 'Introduce el enlace al que quieres que vaya el usuario...',
          },
        },
      },
      platformUpdates: {
        subject: 'Actualizaciones de la plataforma',
        message: 'Hemos introducido algunos cambios en la plataforma.',
        title: 'Nueva actualización de la plataforma',
      },
      newsletter: {
        subject: 'Newsletter',
        message: 'Hemos introducido algunos cambios en la plataforma.',
      },
    },
    userUpdated: 'Usuario actualizado',
    errorUpdatingUser: 'Error al actualizar el usuario',
    notificationsCleared: 'Notificaciones eliminadas',
    notificationSettingsUpdated: 'Configuración de notificaciones actualizada',
    patientDataUpdated: 'Datos del paciente actualizados correctamente',
    patientDataUpdateFailed: 'Error al actualizar los datos del paciente',
    fileDownloadedSuccessfully: 'Archivo 3D descargado correctamente',
    supportEditsAccepted: 'Ediciones de soporte aceptadas',
    supportEditsFailed: 'No se pudieron aplicar las ediciones de soporte',
    changeRequestSubmitted: 'Solicitud de cambio enviada correctamente',
    changeRequestFailed: 'Error al enviar la solicitud de cambio',
    mustBeLoggedIn: 'Debe iniciar sesión para solicitar cambios',
    commentMinLength:
      'Proporcione un comentario de al menos {minLength} caracteres para su solicitud de cambio',
    delete: {
      title: 'Eliminar notificación',
      message: '¿Está seguro de que desea eliminar esta notificación?',
      confirmText: 'Eliminar',
      success: 'Notificación eliminada con éxito',
    },
  },
  navigation: {
    back: 'Volver',
    backToList: 'Volver a la lista',
    backToOverview: 'Volver al resumen',
    breadcrumbs: 'Navegación de migas de pan',
    currentPage: 'Página actual',
    menu: {
      dashboard: 'Tablero',
      patients: 'Pacientes',
      products: 'Productos',
      orders: 'Pedidos',
      explore: 'Explorar',
      support: 'Soporte',
      admin: 'Administración',
      manufacturing: 'Fabricación',
      documentation: 'Documentación',
    },
  },
  editor: {
    save: 'Guardar cambios',
    cancel: 'Cancelar',
    discard: 'Descartar cambios',
    confirmDiscard: '¿Está seguro de que desea descartar sus cambios?',
  },
  menu: {
    notifications: 'Notificaciones',
    messages: 'Mensajes',
    cart: 'Carrito de compras',
    settings: 'Configuración',
    toggleMenu: 'Alternar menú',
    closeMenu: 'Cerrar menú',
    account: 'Cuenta',
    createNew: 'Crear nuevo',
    noNotifications: 'No hay notificaciones',
    noProducts: 'No hay productos en el carrito',
    goToCheckout: 'Ir a la caja',
    accountSettings: 'Configuración de la cuenta',
    logout: 'Cerrar sesión',
    newProduct: 'Nuevo producto',
    newDistributorUser: 'Nuevo usuario distribuidor',
    newMasterUser: 'Nuevo usuario maestro',
    order: 'Ver pedido',
    reactionFromSupport: 'Ver cambios',
    announcement: 'Más información',
    platformUpdates: 'Ver novedades',
    continue: 'Continuar',
  },
  details: {
    noLabel: 'Sin etiqueta',
    noValue: 'Sin valor',
    viewDetails: 'Ver detalles',
    moreInfo: 'Más información',
  },
  cards: {
    viewItem: 'Ver {name}',
    selectItem: 'Seleccionar {name}',
    imageAlt: 'Imagen de {name}',
    showInfo: 'Mostrar información',
    hideInfo: 'Ocultar información',
    favourite: 'Marcar producto como favorito',
    companyFavourite: 'Marcar el producto como favorito de la empresa',
  },
  translation: {
    translate: 'Traducir texto',
    translateTo: 'Traducir a {language}',
    translating: 'Traduciendo...',
    translationError: 'Error al traducir el texto',
    defaultLanguage: 'Idioma predeterminado',
  },
  brand: {
    name: 'OrthoSolid',
    logoAlt: 'Logo de OrthoSolid',
  },
  fileUpload: {
    attachFile: 'Adjuntar archivo',
    dragAndDrop: 'Arrastra y suelta archivos aquí',
    browse: 'Formatos soportados: {formats}',
    maxSize: 'Tamaño máximo de archivo: {size}',
    invalidType: 'Tipo de archivo inválido',
    uploadError: 'Error al subir el archivo',
    loadError: 'No se pudo cargar la vista previa del archivo 3D',
    gltfExternalRefs:
      'Los archivos GLTF con referencias externas no son compatibles. Por favor use formato GLB.',
    uploadSuccess: 'Archivo subido exitosamente',
    remove: 'Eliminar archivo',
    validating: 'Validando archivos...',
    filesNotSupported:
      'Archivo(s) no compatible(s): {rejectedNames}. Formatos admitidos: {acceptedFormats}',
    filesSelected: '{count} de {max} archivos seleccionados',
    uploadInstructions:
      'Su archivo se subirá. Después de la subida, puede limpiar y mejorar el escaneo 3D con nuestra herramienta 3D Cleaner en el siguiente paso.',
    charactersMinimum: '{count}/{min} caracteres mínimo',
    color: {
      label: 'Color',
      incoming: 'Sin color (usar color del archivo)',
      presets: {
        white: 'Blanco',
        skin: 'Piel',
        blue: 'Azul',
        green: 'Verde',
        red: 'Rojo',
        black: 'Negro',
      },
    },
  },
  supportTicket: {
    discussion: 'Discusión',
    typeMessage: 'Escribe un mensaje...',
    send: 'Enviar',
    attachFile: 'Adjuntar archivo',
    noComments: 'No hay comentarios aún',
    addComment: 'Agregar un comentario',
    uploadFile: 'Subir archivo',
    close: 'Cerrar',
    success: 'Se ha creado un ticket de soporte técnico.',
    error: 'Error al crear el ticket de soporte técnico.',
    status: {
      received: 'Recibido',
      under_investigation: 'Bajo investigación',
      on_hold: 'En espera',
      resolved: 'Resuelto',
    },
    productStatus: {
      dataInput: 'Introducción de datos',
      designing: 'Diseñando',
      readyToOrder: 'Listo para pedir',
      inCart: 'En el carrito',
      helpRequested: 'Ayuda solicitada',
      updatedBySupport: 'Actualizado por el servicio de asistencia',
      ordered: 'Pedido',
      demo: 'Demostración',
      designRequested: 'Diseño solicitado',
      orderedWithoutReview: 'Pedido sin necesidad de revisión',
      cancelled: 'Cancelado',
    },
    orderStatus: {
      orderPlaced: 'Pedido realizado',
      processing: 'En proceso',
      shipped: 'Finalizado',
      invoiced: 'Facturado',
      delayed: 'Retrasado',
      ignore: 'Ignorar',
      demo: 'Demostración',
      designRequested: 'Diseño solicitado',
      orderedWithoutReview: 'Pedido sin necesidad de revisión',
      readyForReview: 'Listo para revisión',
      generating3dFile: 'Generando archivo 3D',
      threeDFileUnderReview: 'Archivo 3D en revisión',
      threeDFileAvailable: 'Archivo 3D disponible',
      downloaded: 'Descargado',
    },
    exportStatus: {
      notAvailable: 'N/D',
      generating: 'Generando',
      failed: 'Fallido',
      missing: 'Falta',
      emptyFile: 'Archivo vacío',
      valid: 'Válido',
    },
    buttonText: 'Enviar un mensaje con el enlace al modelo',
  },
  workflow: {
    back: 'Atrás',
    next: 'Siguiente',
    save: 'Guardar',
    exit: 'Salir',
    continue: 'Continuar',
    cancel: 'Cancelar',
    finish: 'Finalizar',
    instructions: 'Instrucciones',
    steps: {
      current: 'Paso actual',
      previous: 'Paso anterior',
      next: 'Siguiente paso',
    },
    navigation: {
      back: 'Volver',
      forward: 'Avanzar',
      exit: 'Salir del flujo',
    },
  },
  patientData: {
    scanOrientation: {
      label: 'Orientación del escaneo',
      placeholder: 'Seleccionar orientación del escaneo',
      left: 'Izquierdo',
      right: 'Derecho',
    },
    dataType: {
      label: 'Tipo de datos',
      file: 'Archivo',
      measurement: 'Entrada de medidas',
      form: 'Formulario',
    },
    upload: {
      alignScan: 'Alinear escaneo',
      defineSide: 'Definir lado del escaneo',
      selectFile: 'Por favor, seleccione un archivo y la orientación del escaneo',
      uploadError: 'Error al subir el archivo',
      description: 'Por favor, seleccione un archivo y la orientación del escaneo',
      action: 'Subir archivo',
    },
    createdOn: 'Creado el',
    notes: 'Notas',
    actions: {
      editScan: 'Editar escaneo',
      editMeasurements: 'Editar medidas',
      editForm: 'Editar formulario',
    },
    add: 'Añadir datos del paciente',
    notFinished: 'No finalizado',
    fields: {
      name: 'Nombre',
    },
    linkedProducts: 'Productos vinculados',
    newProduct: 'Nuevo producto',
    noLinkedProducts: 'No se encontraron productos vinculados',
    dataInput: 'Entrada de datos',
    selectDataInput: 'Seleccione una entrada de datos',
    createdBy: 'Creado por',
    editTitle: 'Editar datos del paciente',
  },
  dataGrid: {
    bulkActions: {
      credits: {
        button: 'Créditos / Product Workflows',
        title: 'Configurar créditos',
        error: {
          notAllowed: 'No está permitido',
          maxSelected: 'Selecciona como máximo {maxSelected} empresas',
          companyId: 'No se ha podido leer la empresa {companyId}',
          invalid: '',
        },
        appliesTo: 'Los cambios se guardan en estas empresas:',
        unchanged: 'Sin cambios',
        saved: '{section} guardado para {count} empresas',
        partiallySaved: 'No se ha podido guardar {section} para: {companies}',
      },
      scheduleExports: 'Programar exportes',
      changeStatus: 'Cambiar estado',
      downloadProduction: 'Descargar archivos de producción',
      downloadCsv: 'Descargar detalles del pedido',
      downloadExports: 'Descargar Exportaciones',
      addToCart: 'Añadir al carrito',
      delete: 'Eliminar',
      notifications: {
        statusSuccess: 'Estado cambiado exitosamente',
        statusError: 'Error al cambiar el estado',
        productionSuccess: 'Archivos de producción descargados exitosamente',
        productionError: 'Error al descargar archivos de producción',
        exportSuccess: 'Exportaciones descargados exitosamente',
        exportError: 'Error al descargar exportaciones',
        exportErrorExplanation: 'No se han encontrado productos descargables.',
        exportErrorNoProducts: 'No downloadable products found.',
        exportErrorIncomplete:
          '{failed} of {total} files could not be downloaded ({products}). Check your connection and try again — nothing was marked as downloaded.',
        cartSuccess: 'Productos añadidos al carrito exitosamente',
        cartError: 'Error al añadir productos al carrito',
        deleteSuccess: 'Productos eliminados exitosamente',
        deleteError: 'Error al eliminar productos',
        exportsSuccess: 'Exportes descargados exitosamente',
        exportsError: 'Error al descargar exportes',
        exportsGenerating:
          'Los exports se están generando. Por favor, inténtelo de nuevo en breve.',
        orderInfoSuccess: '.csv del pedido descargados exitosamente',
        orderInfoError: 'Error al descargar la información del pedido',
      },
    },
    filter: {
      title: 'Filtrar',
      apply: 'Aplicar filtros',
      cancel: 'Cancelar',
    },
    showOnlyMyPatients: 'Mostrar solo mis pacientes',
    showOnlyMyOrders: 'Mostrar solo mis órdenes',
    showOnlyMyProducts: 'Mostrar solo mis productos',
    search: 'Buscar...',
    manageColumns: 'Gestionar columnas',
  },
  help: {
    requestHelp: 'Solicitar ayuda',
    newTicket: 'Crear nuevo ticket',
    openTicket: 'Abrir ticket',
    viewTicket: 'Ver ticket',
  },
  comments: {
    seeModel: 'Ver modelo',
    download: 'Descargar',
    author: 'Por {name}',
    createdAt: 'Creado {date}',
    fileDetails: {
      name: 'Nombre',
      size: 'Tamaño',
      type: 'Tipo',
    },
    selectedFile: 'Archivo seleccionado',
    removeFile: 'Eliminar archivo',
  },
  footer: {
    exploreMore: 'Explorar más productos',
    back: 'Atrás',
    next: 'Siguiente',
    exit: 'Guardar y salir',
    contact: 'Contacto',
    location: 'Ubicación',
    copyright: '© {year} Orthobroker bv',
    followUs: 'Síguenos',
    newsletter: 'Newsletter',
    getUpdates: 'Recibe actualizaciones sobre nuestros últimos productos y ofertas.',
    on: 'On',
    off: 'Off',
    suscribed: 'Te has suscrito a nuestro newsletter',
    unsubscribed: 'Te has desuscribido de nuestro newsletter',
    stayUpToDate: 'Manténgase al día',
    form: {
      email: 'Correo electrónico',
    },
  },
  visibility: {
    show: 'Mostrar datos sensibles',
    hide: 'Ocultar datos sensibles',
  },
  dashboard: {
    startCreation: 'Iniciar flujo de creación',
    addNewPatient: 'Añadir nuevo paciente',
    addPatientData: 'Añadir escáner de paciente',
    continueDesigning: 'Continuar diseñando',
    recentOrders: 'Pedidos recientes',
    viewAll: 'Ver todo',
    columns: {
      productName: 'Nombre del producto',
      patientName: 'Nombre del paciente',
      status: 'Estado',
      orderDate: 'Fecha del pedido',
      orderId: 'ID del pedido',
    },
  },
  redirect: {
    title: 'Redirección Requerida',
    description: 'Necesitas completar algunos pasos antes de acceder a esta página.',
    patient: 'selección de paciente',
    dataset: 'selección de conjunto de datos',
    product: 'selección de producto',
    form: 'selección de formulario',
    goTo: 'Ir a {destination}',
  },
  general: {
    back: 'Atrás',
    exit: 'Guardar y salir',
    yes: 'Si',
    no: 'No',
    on: 'Encendido',
    off: 'Apagado',
  },
  titles: {
    credits: 'Mis créditos',
    patient: 'Asignar paciente',
    assignPatient: 'Asignar paciente',
    createPatient: 'Crear nuevo paciente',
    product: 'Seleccionar producto',
    dataset: 'Seleccionar dataset',
    selectForm: 'Seleccionar formulario',
    editForm: 'Editar formulario',
    newForm: 'Nuevo formulario',
    selectElimb: 'Seleccionar E-limb',
    elimb: 'Medir E-limb',
    selectScan: 'Seleccionar escaneo',
    alignScan: 'Alinear & limpiar escaneo',
    admin: 'Administración',
    catalog: 'Catálogo',
    checkout: 'Caja',
    academy: 'Academia',
    explore: 'Explorar',
    manufacturing: 'Fabricación',
    orders: 'Pedidos',
    dashboard: 'Tablero',
    patientData: 'Datos del paciente',
    products: 'Productos',
    productWorkflowCategory: 'Seleccionar categoría',
    tickets: 'Tickets',
  },
  product: {
    title: 'Producto',
    new: 'Nuevo producto',
    empty: 'No hay productos',
    description: 'Descripción del producto',
    add: 'Añadir producto',
    code: 'Código de producto',
    overview: {
      title: 'Resumen del producto',
    },
    next: 'Seleccionar dataset',
    sections: {
      generalInfo: 'Información general del producto',
      specifications: 'Especificaciones del producto',
      details: 'Detalles del producto',
    },
    fields: {
      status: 'Estado',
      patient: 'Paciente',
      type: 'Tipo de producto',
      id: 'ID del producto',
      createdOn: 'Creado el',
      createdBy: 'Creado por',
      lastAdjustedOn: 'Última actualización el',
      lastAdjustedBy: 'Última actualización por',
      orderReference: 'Referencia del pedido',
      linkedScan: 'Escaneo vinculado',
      copyFrom: 'Copia de',
      edgePiping: {
        0: 'Apagado',
        1: 'En todos lados',
        2: 'Solo mano',
        3: 'Solo el pulgar',
      },
      thumbWebFoldingEdge: {
        0: 'Apagado',
        1: 'Bajo',
        2: 'Medio',
        3: 'Alto',
      },
      buckleType: {
        0: 'Sin hebilla',
        1: 'Bucle FDM',
      },
      dorsal: 'Dorsal',
      palmar: 'Palmar',
      transversalPalmArchIntensity: {
        0: 'Ninguno',
        1: 'Bajo',
        2: 'Medio',
        3: 'Alto',
      },
      productFinishing: {
        0: 'Solo carcasa impresa',
        3: 'Órtesis con forro personalizado',
        1: 'Ortesis con forro personalizado y juego de correas separado',
        2: 'Ortesis con forro personalizado y correas adjuntas',
      },
    },
    properties: {
      title: 'Propiedades del Producto',
      edit: 'Editar Propiedades',
      hinge_type: 'Tipo de Bisagra',
      brace_thickness: 'Grosor del Soporte',
      material: 'Material',
      finishing: 'Acabado',
      error: 'Error al editar las propiedades',
    },
    actions: {
      delete: {
        title: 'Eliminar producto',
        message: '¿Estás seguro de que quieres eliminar este producto?',
        confirmText: 'Eliminar',
        error:
          'El producto {id} no se puede eliminar porque está vinculado al ticket de asistencia {supportTicketId}.',
      },
      addToCart: 'Añadir al carrito',
      removeFromCart: 'Eliminar del carrito',
      order: 'Ir a la caja',
      showSpecifications: 'Mostrar especificaciones',
      showInfo: 'Información del producto',
    },
    workflow: {
      instructions: {
        start: `##### **¿Qué quieres hacer?**
Haz Seleccione la variante más adecuada.
##### **Consejos:**
- Haz clic en el icono de información para obtener una descripción corta del producto`,
        overview: `##### **{title}**
Esta es la ortesis que va a crear.
##### **Consejos:**
- Puede marcar este diseño como favorito haciendo clic en el botón «Favoritos».`,
        flowStepTitle: '##### **{number}. {question}**',
        overviewTitle: '##### **{title}**',
        overviewHeading: 'Descripción general',
        flowStep: `##### **{number}. {question}**
Elija la respuesta que mejor se adapte a su paciente.
##### **Consejos:**
- Puede cambiar una respuesta anterior haciendo clic en su paso más arriba.`,
        noOutcome:
          'Ningún producto coincide con estas respuestas. Vuelva atrás y cambie una respuesta, o pida a un administrador que complete el flujo de decisión.',
        noFlow:
          'Esta familia de productos aún no tiene un flujo de decisión activo. Pida a un administrador que lo active.',
        noOptions:
          'No hay ninguna respuesta disponible para este paso con las respuestas dadas hasta ahora.',
        outcomeFailed:
          'No se pudo cargar el producto de estas respuestas. Compruebe su conexión y recargue la página.',
        outcomeNoWorkflow:
          'Este producto aún no tiene un flujo de producto, así que no se puede crear. Pida a un administrador que lo asigne.',
        error: 'Ha surgido un error al calcular el resultado.',
      },
      thumbDiameter: {
        confirmText: 'Continuar',
        error: 'Introduzca un diámetro de pulgar válido.',
      },
      extraPadding: {
        error: 'Indica si quieres relleno adicional o no.',
        chip: {
          yes: 'Relleno adicional',
          no: 'Sin relleno adicional',
        },
      },
      favourite: {
        title: 'Favorito',
        success: 'Marcado el producto como favorito.',
        error: 'Error al marcar como favorito la configuración de producción de carpi.',
      },
      unFavourite: {
        title: 'Eliminar de favoritos',
        message:
          '¿Estás seguro de que deseas eliminar esta variante de {product} de tu lista de favoritos?',
        confirmText: 'Eliminar',
        success: 'Desmarcado el producto como favorito.',
        error: 'Error al desmarcar el producto como favorito.',
      },
      companyFavourite: {
        title: 'Favorito de la empresa',
        success: 'Marcado el producto como favorito para la empresa.',
        error: 'Error al marcar el producto como favorito para la empresa.',
      },
      companyUnfavourite: {
        title: 'Desmarcar el producto como favorito para la empresa.',
        message:
          '¿Está seguro de que desea eliminar esta variante de {product} de su lista de favoritos para la empresa?',
        confirmText: 'Eliminar',
        success: 'Desmarcar el producto como favorito para la empresa.',
        error: 'Error al desmarcar el producto como favorito para la empresa.',
      },
      outcome: {
        title: 'Resumen general',
      },
      duplicate: {
        baskoMultimotion: 'Basko Multimotion',
        caroliDyna: 'Caroli Dyna',
        caroliMono: 'Caroli Mono',
        albrecht: 'Albrecht',
        ultraFlex: 'UltraFlex',
      },
    },
  },
  productWorkflowCategory: {
    instructions: `##### **¿Qué producto necesita su paciente?**
Seleccione una familia de productos.
##### **Consejos:**
- Haga clic en el icono de información para obtener una breve descripción de los productos 
- Una vez elegida la familia de productos, puede elegir la variante que desea crear`,
    next: 'Seleccionar producto',
  },
  patient: {
    info: 'Información del paciente',
    instructions: `##### **¿Para quién estás creando un producto?**
Crea un nuevo paciente o asigna uno de tu lista de pacientes.`,
    new: 'Crear nuevo paciente',
    pick: 'Seleccionar de lista de pacientes',
    exit: 'Salir',
    next: 'Seleccionar categoría de producto',
    create: 'Añadir nuevo paciente',
    addPatient: 'Añadir Paciente',
    close: 'Cerrar',
    name: 'Nombre del Paciente',
  },
  dataset: {
    elimb: {
      instructions: `##### **¿Cuáles son las medidas del brazo del paciente?**
Crea un nuevo E-limb midiendo a tu paciente o selecciona uno del perfil de tu paciente.
##### **Consejos:**
- Asegúrate de que si eliges un E-limb existente, esté actualizado
- Al crear un nuevo E-limb, asegúrate de tener las siguientes herramientas cerca: Calibrador, regla`,
      create: 'Crear nuevo E-limb',
      select: 'Seleccionar E-limb del perfil del paciente',
      empty: 'No se encontraron E-limbs',
      next: 'Crear E-limb',
      save: 'Definir ángulos de articulación',
    },
    scan: {
      instructions: `##### **¿Cuáles son las medidas del brazo del paciente?**
Sube un nuevo escaneo 3D o selecciona uno del perfil de tu paciente.
##### **Consejos:**
- Asegúrate de que si eliges un escaneo 3D existente, esté actualizado
- Cuando subas un nuevo escaneo 3D, tendrás que alinearlo y limpiarlo.
- Para crear el escaneo perfecto para usar en este software, consulta el Manual de escaneo`,
      upload: 'Subir nuevo escaneo 3D',
      select: 'Seleccionar escaneo 3D del perfil del paciente',
      empty: 'No se encontraron escaneos 3D',
      next: 'Limpiar el escaneo',
      save: 'Guardar escaneo limpiado',
      custom: {
        next: 'Descripción del producto',
      },
    },
    form: {
      assign: 'Asignar formulario',
      empty: 'No hay formularios disponibles',
      instructions: '##### **Por favor, selecciona un formulario para continuar o crea uno nuevo**',
      select: 'Seleccionar formulario',
      new: 'Crear nuevo formulario',
      save: 'Guardar formulario',
      next: 'Siguiente paso',
      request: 'Solicitar producto',
      altNext: 'Solicitar producto',
      altButton: 'Actualizar el formulario',
      name: {
        title: 'Asigne un nombre a su formulario.',
        placeholder: 'Introduzca el nombre.',
      },
    },
    configure: 'Creador de productos',
  },
  list: {
    title: 'Productos',
    empty: 'No se encontraron productos',
    fields: {
      productId: 'ID del Producto',
      productType: 'Tipo de Producto',
      createdOn: 'Creado el',
      status: 'Estado',
    },
    actions: {
      new: 'Nuevo',
    },
  },
  model: {
    locked: 'El modelo está actualmente bloqueado porque ha sido pedido o añadido al carrito.',
  },
  mesh: {
    notFound: {
      title: 'Malla no encontrada',
      message: 'La malla no se encontró en la escena',
    },
    loaded: {
      title: 'Malla cargada',
      message: 'Malla cargada exitosamente',
    },
    align: {
      title: 'Por favor, alinee el escaneado',
      message:
        "Pulse 'Align Scan' antes de guardar el escaneado. \n(Guarde de nuevo para continuar sin alinear)",
    },
    clean: {
      title: 'Por favor, limpie el escaneado',
      message:
        "Pulse 'Clean Scan' antes de guardar el escaneado. \n(Guarde de nuevo para continuar sin limpiar)",
    },
  },
  settings: {
    title: 'Configuración',
    sections: {
      company: 'Configuración de la empresa',
      user: 'Configuración del usuario',
      general: 'Configuración general',
    },
    fields: {
      useOwnPatientId: {
        label: 'Usar ID de paciente propio',
        description: 'Active esta opción para definir sus propios IDs de paciente.',
      },
      sharePatients: {
        label: 'Compartir pacientes',
        description: 'Active esta opción para compartir pacientes con otros usuarios.',
      },
      useShippingInformation: {
        label: 'Usar información de envío',
        description: 'Active esta opción para usar información de envío.',
      },
      anonymizedStartUp: {
        label: 'Inicio anónimo',
        description: 'Active esta opción para un inicio anónimo.',
      },
      assistedMode: {
        label: 'Modo asistido',
        description: 'Active esta opción para el modo asistido.',
      },
      preferredLanguage: {
        label: 'Idioma preferido',
        description: 'Seleccione su idioma preferido.',
      },
    },
    myAccount: 'Mi cuenta',
    announcement: {
      button: 'Enviar un nuevo anuncio',
    },
    platformUpdate: {
      button: 'Enviar una actualización de la plataforma',
    },
    notificationSettings: 'Configuración de notificaciones',
    notifications: {
      inPlatform: 'En la plataforma',
      byEmail: 'Por correo electrónico',
    },
  },
  scan: {
    title: 'Escaneo 3D',
    fields: {
      id: 'ID del Escaneo',
      name: 'Nombre del Escaneo',
      orientation: 'orientación del escaneo',
      lastAdjustedOn: 'última modificación el',
      lastAdjustedBy: 'última modificación por',
    },
  },
  elimb: {
    title: 'Information del Elimb',
    fields: {
      id: 'ID del elimb',
      name: 'Nombre del elimb',
      orientation: 'orientación del elimb',
      lastAdjustedOn: 'última modificación el',
      lastAdjustedBy: 'última modificación por',
    },
  },
  descriptions: {
    credits: 'Compra créditos y consulta lo que tu organización todavía puede imprimir.',
    products: 'Productos',
    admin: 'Administración',
    catalog: 'Catálogo',
    checkout: 'Caja',
    academy: 'Academia',
    explore: 'Explorar',
    orders: 'Pedidos',
    tickets: 'Tickets',
  },
  distributor: {
    create: 'Crear Distribuidor',
    add: 'Añadir usuario',
  },
  cart: {
    empty: 'El carrito está vacío',
    delete: {
      title: 'Eliminar del carrito',
      message: '¿Está seguro de que desea eliminar este artículo de su carrito?',
      confirmText: 'Eliminar',
      success: 'Artículo eliminado del carrito con éxito',
    },
  },
  checkout: {
    title: 'Caja',
    contactInformation: {
      title: 'Información de Contacto',
      description: 'Descripción de la Información de Contacto',
    },
    products: {
      title: 'Productos',
      description: 'Descripción de Productos',
    },
  },
  academy: {
    title: 'Academia',
  },
  manufacturing: {
    title: 'Fabricación',
    orders: {
      title: 'Fabricación - Pedidos',
      tab: 'Pedidos habituales',
    },
    designRequested: {
      title: 'Fabricación - Diseño solicitado',
    },
    ignoredItems: {
      title: 'Fabricación - Artículos ignorados',
      tab: 'Artículos ignorados',
    },
    creditOrders: {
      title: 'Fabricación - Solicitudes de créditos',
      tab: 'Solicitudes de créditos',
    },
    noItemsFound: 'No se encontraron artículos de fabricación',
    stlFiles: 'Archivos STL',
    rows: {
      selectRow: 'Seleccionar fila',
      unselectRow: 'Deseleccionar fila',
      selectAllRows: 'Seleccionar todas las filas',
      unselectAllRows: 'Deseleccionar todas las filas',
    },
  },
  tickets: {
    fields: {
      product: 'Producto',
      status: 'Estado',
      createdBy: 'Creado por',
      id: 'ID del Ticket',
      involving: 'Relacionado con',
      description: 'Descripción',
      company: 'Empresa',
    },
  },
  products: {
    fields: {
      status: 'Estado',
      name: 'Nombre',
      patientName: 'Nombre del Paciente',
      id: 'ID del Producto',
      notes: 'Notas',
      producedBy: 'Producido por',
    },
  },
  documentation: {
    title: 'Documentación',
    notAvailable: 'No hay documentación disponible en este momento.',
    loading: 'Cargando contenido...',
    selectDocument: 'Seleccione un documento de la tabla de contenidos.',
  },
  explore: {
    title: 'Explorar',
  },
  components: {
    selectPatient: 'Seleccionar un paciente',
    patientLabel: 'Paciente',
    meshInspectorFrame: 'Marco de MeshInspector',
    doNotShowAgain: 'No mostrar esta ventana la próxima vez',
    submitText: 'Empieza a diseñar',
    supportPreview: {
      title: 'Vista previa de soporte',
      description: 'Estás viendo una vista previa de soporte. Acepte los cambios para continuar',
      accept: 'Acepte',
    },
    modelPreviews: {
      viewSelection: 'selección de vista del modelo',
      productView: 'vista del producto',
      patientDataView: 'vista de datos del paciente',
      finalProduct: 'Producto Final',
      threeDScan: 'Escaneo 3D',
    },
    meshInspector: {
      saveWarnings: {
        title: 'Guardar escaneo',
        lead: 'Antes de guardar, ten en cuenta:',
        notCleanedBullet: "La malla no está limpia. Usa 'Clean Scan' para sanearla.",
        notAlignedBullet: "El escaneo no está alineado. Usa 'Align Scan' para orientarlo.",
        proceed: 'Guardar de todas formas',
      },
    },
    customProducts: {
      noFormDataAvailable: 'No hay datos de formulario disponibles para este producto.',
      changeRequestHistory: 'Historial de Solicitudes de Cambio',
      anonymous: 'Anónimo',
      uploadModel: 'Subir modelo',
      uploadModelTitle: 'Subir Modelo',
      productFormData: 'Datos del Formulario del Producto',
      requestChangesButton: {
        title: 'Solicitar cambios',
        description:
          'Esta solicitud cambiará el estado del producto y notificará al equipo de OrthoSolid. Nuestro equipo revisará sus comentarios y le proporcionará una nueva versión del producto basada en sus especificaciones.',
      },
      buttons: {
        orderTitle: 'Aceptar y realizar el pedido',
      },
      images: {
        title: 'Imágenes adjuntas',
        description: 'Subir nuevas imágenes',
      },
      requestProduct: {
        dialog: {
          title: 'Solicitar producto personalizado',
          message: `Al solicitar este producto, crearemos un diseño personalizado y, al final, se le enviará la factura.\n\n**Importante:**\n\nTenga en cuenta que la creación del diseño puede tardar hasta 3 días laborables. Se le mantendrá informado a través de las notificaciones de la plataforma y por correo electrónico.`,
          confirmText: 'Solicitar producto',
        },
      },
      orderProduct: {
        dialog: {
          title: 'Pedir producto',
          message: `Al pedir este producto, crearemos e imprimiremos un diseño personalizado sin tu verificación. El producto se enviará y se facturará.\n\n**Importante:**\n\nTen en cuenta que la creación del producto puede tardar hasta 12 días laborables. Te mantendremos informado a través de las notificaciones de la plataforma y por correo electrónico.`,
          confirmText: 'Pedir producto',
        },
      },
      updateForm: {
        dialog: {
          title: 'Actualizar formulario',
          message:
            'Al actualizar el formulario, esto también se aplicará a otros productos que utilicen este formulario.',
        },
      },
    },
  },
  youtubeEmbed: {
    player: 'Reproductor de YouTube',
    allowedFeatures:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  },
  formFields: {
    togglePasswordVisibility: 'alternar visibilidad de la contraseña',
  },
  features: {
    currentlyDisabled: 'Esta función está actualmente deshabilitada',
  },
  configurator: {
    calculating: 'Calculando...',
    error: {
      title: 'Error',
      description: 'Producto no encontrado.',
      brace: {
        title: 'Es necesario calcular un soporte antes de poder ocultarlo.',
      },
    },
    menu: {
      customTextLimit: 'Introduzca hasta 20 caracteres. (Se utiliza {length})',
      notes: {
        title: 'Información para la producción',
        productLabel: 'Incluir el nombre del paciente en la etiqueta del producto',
        placeholder: 'Haga clic para añadir notas...',
      },
    },
  },
  volarShell: {
    error: {
      noAcces: 'No tienes acceso a este producto.',
      noShell: 'No hay ningún archivo shell disponible para este producto.',
      couldNotGenerate: 'No se ha podido generar un enlace de descarga para el archivo shell.',
      failed: 'No se ha podido obtener el archivo shell.',
    },
  },
  stlDownload: {
    buttonSingular: {
      title: 'Descargar archivo 3D',
    },
    buttonMultiple: {
      title: 'Descargar archivos 3D',
    },
    buttonMultipleOrSingular: {
      title: 'Descargar archivo(s) 3D',
    },
    buttonGenerating: {
      title: 'Generando archivo 3D',
    },
    buttonGeneratingMultiple: {
      title: 'Generando archivo(s) 3D',
    },
    notification: {
      success: '¡Archivos 3D descargados correctamente!',
    },
  },
  demo: {
    form: {
      title: 'Orthosolid Demo',
      email: 'Correo electrónico',
      name: 'Nombre completo',
      company: 'Empresa',
      carpi: 'Orthosolid Carpi Demo',
      mino: 'Orthosolid Mino Demo',
      volar: 'Orthosolid Volar Demo',
    },
    reset: 'Restablecer',
    contactForm: {
      title: 'Formulario de contacto',
      field: 'Texto',
      placeholder: 'Escriba su mensaje para Orthobroker.',
    },
  },
  notificationTypes: {
    creditsLow: 'Saldo de créditos bajo',
    creditsRequested: 'Solicitudes de créditos',
    orderPlaced: 'Pedido realizado',
    orderInProcess: 'Pedido en proceso',
    orderDelayed: 'Pedido retrasado',
    orderShipped: 'Pedido finalizado',
    orderInvoiced: 'Pedido facturado',
    reactionsFromSupport: 'Reacciones del soporte',
    platformUpdates: 'Actualizaciones de la plataforma',
    newsletter: 'Boletín informativo',
  },
  insights: {
    useCases: 'Casos de uso',
    guides: 'Guías',
    webinars: 'Seminarios web',
    comparisons: 'Comparaciones',
  },
  website: {
    menu: 'Menú',
  },
  marketingWebsite: {
    contact: {
      form: {
        name: 'Name',
        company: 'Company',
        email: 'Email',
        message: 'Message',
        submit: 'Submit',
        value: 'Value',
        success:
          'Gracias por ponerse en contacto con OrthoSolid. Nos pondremos en contacto con usted en breve.',
        error:
          'Ha habido un error al procesar su mensaje. Le sugerimos que nos envíe un correo electrónico directamente a info@orthobroker.com.',
        recaptchaError: 'Por favor, complete el reCAPTCHA.',
      },
    },
  },
  addToCart: {
    errors: {
      noInput:
        'Parece que no se ha seleccionado ningún producto. Inténtalo de nuevo con un producto.',
      notReadyToOrder:
        'Este producto aún no está listo para su pedido. Modifícalo antes de realizar el pedido.',
      addingToCart:
        'Se ha producido un error al añadir el producto al carrito. Ponte en contacto con el servicio de atención al cliente.',
    },
  },
  credits: {
    checkout: {
      title: 'Créditos',
      cost: 'Este pedido cuesta',
      balance: 'Tu saldo',
      after: 'Saldo tras este pedido',
      amount: '{credits} créditos',
      amountOne: '1 crédito',
      alreadyPaid: 'Ya pagado',
      unknownCost: 'Precio desconocido',
      shortfall: 'Te faltan {credits} créditos para realizar este pedido.',
      shortfallOne: 'Te falta 1 crédito para realizar este pedido.',
      buy: 'Comprar créditos',
      requestMore: 'Solicitar más créditos',
      unpriced:
        'Uno o más productos digitales de este pedido aún no tienen precio en créditos. Contacta con Orthobroker antes de pedir.',
      covered: 'Tu saldo cubre este pedido.',
    },
    cart: {
      blocked: 'No tienes créditos suficientes para este producto. Te faltan {credits} créditos.',
      blockedOne: 'No tienes créditos suficientes para este producto. Te falta 1 crédito.',
      blockedUnpriced:
        'Este producto aún no tiene precio en créditos. Contacta con Orthobroker antes de añadirlo.',
    },
    request: {
      sent: 'Tu solicitud se ha enviado a los administradores de tu organización.',
      sentShort: 'Solicitud enviada',
      noAdmins:
        'Tu organización no tiene ningún administrador al que enviar esta solicitud. Contacta con Orthobroker.',
      failed: 'No hemos podido enviar tu solicitud. Inténtalo de nuevo.',
    },
    available: 'Créditos disponibles',
    topUp: 'Recargar',
    requestMore: 'Solicitar más créditos',
    requestMoreHint: 'Pide a un administrador de tu empresa que recargue los créditos.',
    expiry: '{amount} créditos caducan el {date}',
    expiryOne: '1 crédito caduca el {date}',
    printsLeft: 'Quedan {prints} impresiones',
    printsLeftOne: 'Queda 1 impresión',
    noPacks: 'No hay packs de créditos disponibles en este momento.',
    loadError: 'No se han podido cargar tus créditos. Inténtalo de nuevo.',
    currency: {
      label: 'Cambiar moneda:',
      note: 'Los precios mostrados en monedas distintas del EUR son indicativos.',
    },
    orderStatus: {
      requested: 'Solicitado',
      confirmed: 'Confirmado',
      cancelled: 'Cancelado',
    },
    table: {
      distributor: 'Distribuidor',
      credits: 'Créditos',
      price: 'Precio',
      pack: 'Paquete',
      requestedBy: 'Solicitado por',
      requestedAt: 'Solicitado el',
      confirmedAt: 'Confirmado el',
    },
    pack: {
      save: 'Ahorra {amount}',
      prints: '{prints} impresiones',
      printsOne: '1 impresión',
      add: 'Añadir',
      addHint: 'Solicita este pack. Orthobroker te facturará y añadirá los créditos.',
      expiry: 'Los créditos comprados hoy caducarán el {date}',
      requested: 'Solicitado',
      requestSuccessTitle: 'Solicitud enviada',
      requestSuccess:
        'Hemos recibido tu solicitud de {credits} créditos. Orthobroker te facturará y los créditos se añadirán cuando se confirme el pago.',
      requestNotAllowed:
        'El administrador de tu empresa es quien debe solicitar créditos para tu organización.',
      requestUnavailable: 'Este pack no está disponible para tu empresa en este momento.',
      rateUnavailable:
        'Se muestra en euros: el tipo de cambio de {currency} no está disponible ahora mismo.',
      requestFailed: 'No hemos podido enviar tu solicitud. Inténtalo de nuevo.',
    },
    categories: {
      carpi: 'Carpi',
      mino: 'Mino',
      volar: 'Volar',
    },
    faq: {
      title: 'Sobre los créditos',
      q1: '¿Qué son los créditos?',
      a1: 'Los créditos sirven para comprar archivos digitales que puedes imprimir en 3D en tu propio centro.',
      q2: '¿Los productos fabricados por Orthobroker están incluidos en el sistema de créditos?',
      a2: 'No. Los productos fabricados y entregados por Orthobroker se facturan por separado.',
      q3: '¿Se pueden compartir los créditos dentro de mi organización?',
      a3: 'Sí. Los créditos se comparten en toda tu organización y pueden usarlos todos los profesionales.',
      q4: '¿Caducan los créditos?',
      a4: 'Sí. Todos los créditos caducan {months} meses después de la fecha de compra.',
      q5: '¿Cuántos créditos cuesta un archivo digital?',
      a5: 'La cantidad de créditos necesaria depende del producto concreto y se muestra antes de la compra.',
    },
  },
  decisionFlows: {
    title: 'Flujos de decisión de producto',
    description:
      'Crea sin código el cuestionario que elige un producto y sus parámetros iniciales.',
    loading: 'Cargando flujos',
    saving: 'Guardando…',
    flow: 'Flujo',
    untitled: 'Sin título',
    reorder: 'Reordenar {name}: arrástralo, usa las flechas o ábrelo para subirlo o bajarlo',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    tabs: {
      questions: 'Preguntas',
      outcomes: 'Resultados finales',
      credits: 'Sistema de créditos',
      simulator: 'Probar',
    },
    credits: {
      intro:
        'Decida cuándo un producto creado con este flujo consume créditos de la cuenta del cliente. La regla se comprueba al pedir el producto.',
      match: 'Consumir créditos cuando',
      matches: {
        all: 'Se cumplen todas las condiciones (Y)',
        any: 'Se cumple alguna condición (O)',
      },
      legend: 'Condiciones',
      noQuestions:
        'Ninguna pregunta guarda su respuesta en la configuración del producto, así que ninguna puede decidir los créditos.',
      unpriced:
        'Esta categoría no tiene precio en créditos, así que el pago rechaza cualquier producto que la regla seleccione.',
      fallback:
        'Sin condiciones: se aplica la regla integrada y solo consumen créditos los productos que el cliente produce por su cuenta.',
    },
    toolbar: {
      importJson: 'Importar JSON',
      exportJson: 'Exportar JSON',
      imported: '{title} importado',
      exported: '{file} exportado',
      fileTooLarge: 'El archivo supera {size}.',
      hideList: 'Ocultar la lista',
      showList: 'Mostrar la lista',
    },
    flows: {
      none: 'Todavía no hay flujos. Crea el primero para empezar.',
      create: 'Nuevo flujo',
      createTitle: 'Nuevo flujo',
      settingsTitle: 'Ajustes del flujo',
      name: 'Nombre del flujo',
      category: 'Categoría de producto',
      categoryHint: 'Decide entre qué productos puede elegir este flujo.',
      noCategory: 'Sin categoría',
      saveSettings: 'Guardar ajustes',
      duplicateTitle: 'Duplicar flujo',
      duplicate: 'Crear copia',
      copyName: '{title} (copia)',
      live: 'Usar en la creación de productos',
      liveHint:
        'La creación de productos de esta categoría sigue este flujo. Al activarlo se desactiva cualquier otro flujo de la categoría.',
      liveNeedsCategory:
        'Elija primero una categoría de producto: el flujo guía la creación de productos de esa categoría.',
      liveWithIssues:
        'Este flujo tiene {count} problemas. La creación de productos se detiene donde dejan un hueco.',
      liveTag: 'en creación de productos',
      cancel: 'Cancelar',
      delete: 'Eliminar flujo',
      more: 'Más acciones del flujo',
    },
    deleteFlow: {
      title: '¿Eliminar este flujo?',
      body: 'Se eliminará {title} con sus preguntas y sus resultados finales. No se puede deshacer.',
      confirm: 'Eliminar flujo',
    },
    confirmDelete: {
      confirm: 'Eliminar',
      cancel: 'Cancelar',
      title: '¿Eliminar {name}?',
      conditionTitle: '¿Eliminar la condición sobre {question}?',
      combinationTitle: '¿Eliminar la combinación {number}?',
      question:
        'Sus respuestas se van con ella, y las condiciones y combinaciones que la leen la olvidan. No se puede deshacer.',
      answer:
        'Las condiciones y combinaciones que eligen esta respuesta la olvidan. No se puede deshacer.',
      condition: 'Sin ella, esto ya no depende de esa pregunta. No se puede deshacer.',
      parameter: 'Este valor deja de aplicarse. No se puede deshacer.',
      dialog: 'Se eliminan el diálogo y sus opciones. No se puede deshacer.',
      choice: 'Se eliminan la opción y sus parámetros. No se puede deshacer.',
      combination:
        'Estas respuestas dejan de elegir su producto. La configuración de producto se conserva. No se puede deshacer.',
    },
    stepTypes: {
      decisionQuestion: 'Pregunta',
    },
    fields: {
      target: 'Se aplica a',
      targets: {
        shapediver: 'Modelo 3D',
        product: 'Producto',
      },
      numberRequired: 'Introduce un número',
      translate: 'Traducir del inglés',
      translations: 'Traducciones ({filled}/{total})',
      translateFailed: 'No se tradujo nada. Inténtalo de nuevo en un momento.',
      linked: 'Compartido con el asistente de producto: un cambio aquí también se ve allí',
      linkedNameKept:
        'El nombre es obligatorio: se conserva el guardado hasta que escribas uno nuevo',
      translated: 'Traducido a {count} idiomas',
      markdown: {
        bold: 'Negrita',
        italic: 'Cursiva',
        heading: 'Encabezado',
        bulletList: 'Lista con viñetas',
        orderedList: 'Lista numerada',
      },
      pick: 'Elige un campo…',
      unknown: '{name} (no es un parámetro del modelo 3D)',
      unknownError:
        '{name} no es un parámetro de los modelos 3D de los productos de {category} que este flujo puede crear. Elige uno de la lista.',
      modelHint:
        'De los modelos 3D de los productos de {category} que este flujo puede crear. Un nombre que no tienen todos los productos indica cuáles lo tienen.',
      modelEmpty:
        'Los productos de {category} aún no tienen una sesión de ShapeDiver sincronizada, así que no hay parámetros para elegir.',
      misspelled: 'Escrito distinto en otros modelos',
      spellingWarning:
        'Otros modelos 3D escriben este parámetro {spellings}. Un valor solo llega a los modelos que lo escriben exactamente así: renombra el parámetro en ShapeDiver para que todos los modelos coincidan.',
      noCategory:
        'Asigna primero una categoría a este flujo: los modelos 3D de sus productos son lo que puedes elegir aquí.',
    },
    questions: {
      empty: 'Este flujo todavía no tiene preguntas. Añade la primera aquí abajo.',
      count: 'Preguntas: {count}',
      addQuestion: 'Añadir pregunta',
      questionTitle: 'Pregunta',
      instructionsTitle: 'Título de la tarjeta verde',
      instructionsTitleHint:
        'Encabezado de la tarjeta verde en el asistente de producto. Si se deja vacío, se muestra la pregunta.',
      instructions: 'Texto de la tarjeta verde',
      instructionsHint: 'Markdown que se muestra bajo la pregunta en el asistente de producto',
      answerField: 'Parámetro del configurador',
      answerFieldHint:
        'Cada respuesta da su valor a este parámetro del modelo 3D. Si se deja vacío, la pregunta no ajusta nada en el configurador.',
      disabled: 'Deshabilitada',
      disabledDescription:
        'Se aplica en el diálogo para duplicar un producto en otra configuración',
      companyHidable: 'Ocultable por empresa',
      companyHidableDescription:
        'Aparece en la pestaña Flujos de trabajo de productos de una empresa, donde sus respuestas se pueden ocultar para esa empresa',
      decidedValue: 'Valor de {field}',
      setDecidedValue: 'Fijar {field}',
      clearDecidedValue: 'Borrar el valor de {field}',
      answerCount: '{count} respuestas',
      options: 'Respuestas',
      optionLabel: 'Respuesta',
      addOption: 'Añadir respuesta',
      olderParameters:
        'También fija {values}, de antes de que las respuestas perdieran su lista de parámetros.',
      removeOlderParameters: 'Quitarlos',
      removeOption: 'Quitar la respuesta {name}',
      deleteStep: 'Eliminar {name}',
      parameterName: 'Se guarda en',
      min: 'Mínimo',
      max: 'Máximo',
      step: 'Incremento',
      unit: 'Unidad',
      defaultValue: 'Valor por defecto',
    },
    conditions: {
      stepLegend: 'Preguntar solo si',
      optionLegend: 'Mostrar solo si',
      question: 'Pregunta',
      answers: 'Respuestas',
      add: 'Añadir condición',
      remove: 'Quitar la condición sobre {question}',
      pickAnswers: 'Elige al menos una respuesta',
    },
    dialogs: {
      add: 'Añadir diálogo',
      count: 'Diálogos',
      dialogTitle: 'Título del diálogo',
      description: 'Descripción',
      control: 'Control',
      controls: {
        single: 'Una opción',
        multi: 'Varias opciones',
        number: 'Número',
        text: 'Texto',
      },
      optional: 'Opcional',
      showOnOutcome: 'Mostrar en la tarjeta del resultado final',
      choiceLabel: 'Opción',
      addChoice: 'Añadir opción',
      skip: 'Omitir',
      removeChoice: 'Quitar la opción {name}',
      remove: 'Quitar el diálogo {name}',
      value: 'Valor',
    },
    outcomes: {
      addRow: 'Añadir combinación',
      overviewTitle: 'Título de la descripción general',
      overviewTitleHint:
        'Encabezado de la tarjeta verde del último paso del asistente. Si se deja vacío, se muestra Descripción general.',
      overview: 'Texto de la descripción general',
      overviewHint:
        'Markdown en la tarjeta verde del último paso del asistente, Descripción general. Si se deja vacío, se muestra el texto predeterminado.',
      addMissing: 'Añadir las combinaciones que faltan',
      missingTitle: 'Combinaciones que faltan: {count}',
      addMissingRow: 'Añadir combinación',
      addMissingRowFor: 'Añadir combinación para {answers}',
      missingMore:
        'Hay {count} más sin listar. «Añadir las combinaciones que faltan» las añade todas.',
      anyAnswer: 'Cualquier respuesta',
      rowCount: 'Combinaciones: {count}',
      hint: 'Elige todas las respuestas que cubre cada combinación. Las que sus otras celdas descartan aparecen en gris, y una pregunta que nunca hace queda vacía.',
      table: 'Tabla de resultados finales',
      actions: 'Acciones',
      any: 'Cualquiera',
      choose: 'Elegir…',
      notAsked: 'No se pregunta',
      name: 'Nombre',
      image: 'Imagen',
      answerCell: '{question}, combinación {number}',
      openDetails: 'Detalles de la combinación {number}',
      deleteRow: 'Eliminar combinación {number}',
      details: 'Combinación {number}',
      productTemplate: 'Flujo de producto',
      productHint:
        'Al guardar la combinación se crea una configuración de producto propia con el nombre, el flujo, la imagen y las respuestas.',
      linkedHint:
        'Los cambios se aplican al guardar la combinación. Un producto que usa otro flujo u otra categoría recibe su propia copia.',
      discard: 'Descartar',
      saveRow: 'Guardar combinación {number}',
      saved: 'Combinación {number} guardada',
      close: 'Cerrar',
      product: 'Producto',
      imageUpload: 'Subir imagen',
      imageReplace: 'Cambiar imagen',
      imageUploading: 'Subiendo…',
      imagePending: 'Se guarda con la combinación',
      imageNeedsSave: 'Guarda primero la combinación: la imagen pertenece al producto que crea.',
      imageFailed: 'No se pudo subir la imagen. Inténtalo de nuevo.',
      imageBrowse: 'Ver la imagen en la galería',
    },
    parameters: {
      title: 'Parámetros',
      name: 'Campo',
      remove: 'Quitar el parámetro {name}',
      valueType: 'Tipo de valor',
      reservedName: 'Este nombre está reservado, elige otro.',
      valueTypes: {
        decisionParameterNumber: 'Número',
        decisionParameterBoolean: 'Sí / no',
        decisionParameterString: 'Texto',
      },
      value: 'Valor',
      add: 'Añadir parámetro',
      help: 'Valores que fija cuando se aplica, cada uno para un parámetro del modelo 3D o un campo de producto. El destino y el tipo del valor siguen al campo.',
      pickOption: 'Elige una opción…',
      unsynced:
        'Sincroniza la sesión de ShapeDiver de este parámetro para elegir entre sus opciones.',
      true: 'Verdadero',
      false: 'Falso',
    },
    simulator: {
      title: 'Prueba el cuestionario',
      restart: 'Empezar de nuevo',
      change: 'Cambiar',
      changeAnswer: 'Cambiar la respuesta a {question}',
      valueHint: 'Entre {min} y {max}',
      outOfRange: 'Introduce un valor entre {min} y {max}',
      result: 'Producto seleccionado',
      shapediverParameters: 'Ajustes del modelo 3D',
      productParameters: 'Parámetros del producto',
      noParameters: 'Ninguno',
      invalid: 'El cuestionario no puede continuar:',
    },
    issues: {
      none: 'No se encontraron problemas',
      count: 'Problemas: {count}',
      emptyQuestion: 'Esta pregunta no tiene respuestas.',
      emptyFlow: 'El flujo no tiene pasos.',
      unknownCondition: 'Una condición usa una pregunta que no está en el flujo.',
      forwardCondition: 'Una condición usa una pregunta que se hace más tarde.',
      resultWithoutProduct: 'Esta combinación no tiene producto.',
      unknownAnswer: 'Una condición o una combinación apunta a una respuesta que ya no existe.',
      unreachableResult:
        'Una combinación más específica siempre gana a esta, así que nunca se usa.',
      conflictingResults: 'Otra combinación es igual de específica para las mismas respuestas.',
      impossibleResult:
        'Estas respuestas nunca pueden darse juntas, así que esta combinación nunca se usa.',
      unansweredCell: 'Elige las respuestas que cubre esta combinación en cada pregunta que hace.',
      impossibleAnswer:
        'Una respuesta elegida aquí nunca puede darse con las otras respuestas de esta combinación.',
      duplicateResult: 'Otra combinación tiene exactamente las mismas respuestas.',
      missingResult: 'Algunas combinaciones de respuestas no llevan a ningún producto.',
      tooManyCombinations:
        'Este flujo tiene demasiadas combinaciones de respuestas para revisarlo por completo.',
      emptyDialog: 'Este diálogo no pregunta nada: no tiene opciones ni un parámetro que rellenar.',
      invalidDialogBounds: 'El mínimo supera al máximo o el incremento no es mayor que cero.',
      undeclaredAnswerField:
        'Esta pregunta ajusta un parámetro del configurador que no tienen los modelos 3D que este flujo puede crear.',
      unknownProductField:
        'Esta respuesta fija un valor de producto que no es un campo del producto, así que los productos nuevos lo descartan. Envíalo al modelo 3D.',
      invalidCreditCondition:
        'Una condición de créditos no tiene respuestas o lee una pregunta cuya respuesta no se guarda en el producto, así que los pedidos la ignoran.',
    },
    parseErrors: {
      invalidJson: 'El archivo no es un JSON válido.',
      notAFlow: 'El archivo no es un flujo de decisión de producto.',
      invalidStep: 'Un paso no es válido ({path}).',
      invalidOption: 'Una respuesta no es válida ({path}).',
      invalidParameter: 'Un parámetro no es válido ({path}).',
      invalidResult: 'Una combinación no es válida ({path}).',
      invalidCondition: 'Una condición no es válida ({path}).',
      invalidDialog: 'Un diálogo no es válido ({path}).',
      invalidAnswerField: 'Un campo de pregunta no es válido ({path}).',
      duplicateKey: 'Dos elementos comparten la misma clave ({path}).',
      unknownField: 'El archivo tiene un campo que el formato del flujo no reconoce ({path}).',
      tooLarge: 'El flujo tiene demasiados elementos para abrirlo ({path}).',
    },
    storage: {
      'not-allowed':
        'Sanity rechazó esta acción. Comprueba que has iniciado sesión y que tu rol la permite.',
      otherDataset: 'Los flujos de decisión solo se editan en el espacio de trabajo {dataset}.',
      openDataset: 'Abrir el editor de {dataset}',
      linkedFailed:
        'No se pudo guardar un texto compartido. Recarga esta pestaña para ver la versión guardada.',
      'not-found': 'Ese flujo ya no existe.',
      dropped: 'Se omitieron flujos que no se pudieron leer: {count}.',
      invalid: 'No se pudieron guardar los cambios porque el flujo no es válido.',
      failed: 'No se pudieron guardar los cambios. Inténtalo de nuevo.',
    },
  },
};

export default es;
